/* eslint-disable jsx-a11y/anchor-is-valid */
import './index.less';
import { SearchOutlined } from '@ant-design/icons';
import { Input, Button, Space, Table, Tag, Pagination, Spin, Modal, message } from 'antd';
// import EmptyIcon from '@/assets/empty.png'; // 无数据状态的背景图
import { EmptyFileColor } from 'patternx-svg';
import { useState, useRef, useEffect } from 'react';
// 添加公司按钮弹窗组件
import AddCompany from './addCompony';
// 导入接口
import * as api from '@/services/enterprise';
import PtxEmpty from '@/components/ptx-empty';

const ComponyList = () => {
  useEffect(() => {
    // 页面初始化
    getCompanyList();
  }, []);

  // 搜索公司
  const inputValue = useRef();
  const onInputChange = (e: any) => {
    inputValue.current = e.target.value;
    if (e.target.value === '') {
      console.log('全部删除');
      getCompanyList(); // 搜索框内容全部删除时重新获取列表
    }
  };
  const searchUsers = async (value: any) => {
    setTableLoad(true);
    console.log('搜索公司', value);
    const res = await api.getCompany({
      // pageIndex: page,
      // pageSize: size,
      companyName: value,
    });
    console.log(res, '公司搜索');
    setTableLoad(false);
    if (res?.success && res.code === 200) {
      if (res?.data?.total > 0) {
        setPage(res.data.current);
        setData(res?.data?.records);
        setTotal(res?.data?.total);
      } else if (res?.data?.total === 0) {
        // getCompanyList(); // 找不到公司时初始化表格
        message.error('未能找到相关公司');
        setPage(1);
        setData([]);
        setTotal(0);
      }
    } else {
      message.error('搜索公司错误');
      setData([]);
    }
  };

  // 表格参数
  // 表格表头-纵向数据设置
  const columns: any = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, record: any, index: any) => (
        console.log('序号', index), (<Space>{index + 1}</Space>)
      ),
      width: 80,
    },
    {
      title: '公司名称',
      dataIndex: 'name',
      key: 'name',
      // render: (_: any, record: any) => {
      //   console.log('公司名称', _, record);
      //   let components = _?.split(inputValue.current);
      //   const nameArray = [components.shift(), components.join('')];
      //   const searchName = inputValue.current === '' && nameArray[1] !== '';
      //   console.log('公司名称', nameArray);
      //   return searchName ? (
      //     <Space>
      //       <div>{record.name}</div>
      //     </Space>
      //   ) : (
      //     <Space>
      //       <div>
      //         {nameArray[0]}
      //         <span
      //           style={{
      //             color: '#5F4DFF',
      //             backgroundColor: '#f4f0ff',
      //             height: '22px',
      //             lineHeight: '22px',
      //           }}
      //         >
      //           {inputValue.current}
      //         </span>
      //         {nameArray[1]}
      //       </div>
      //     </Space>
      //   );
      // },
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: any) => (
        console.log(record, _, 'render'),
        (
          <Space size="middle">
            <a
              onClick={(e) => {
                console.log('编辑公司', _, record);
                setComId(record.id); // 向组件内传递公司信息
                setOpenAddCompany(true);
                setAddTitle('编辑公司');
                setComName(record.name);
              }}
            >
              编辑
            </a>
          </Space>
        )
      ),
      width: 120,
    },
  ];

  //设置编辑公司名字
  const [comName, setComName] = useState('');

  // 设置弹窗名字
  const [addTitle, setAddTitle] = useState('');

  // 表格每行横向数据设置
  const [data, setData] = useState([]);

  // 表格加载
  const [tableLoad, setTableLoad] = useState(true);

  // 搜索输入内容
  const searchInputRef = useRef<any>(null);
  const [param, setParam] = useState<string>('');

  // 表格初始化
  const getCompanyList = async () => {
    setTableLoad(true);
    // const res = await api.getCompanyList()
    const res = await api.getCompany({
      pageIndex: page,
      pageSize: size,
      companyName: inputValue.current,
    });

    console.log(res, '公司列表初始化');
    // api.debounce(setTableLoad(false),500)
    setTableLoad(false);
    if (res?.success && res.code === 200) {
      if (res.data.records.length === 0) {
        message.error('未能找到相关公司');
      } else {
        setData(res?.data?.records);
        setTotal(res?.data?.total);
      }
    } else {
      message.error('获取公司列表错误');
      setData([]);
    }
  };
  const [page, setPage] = useState<number>(1); // 当前页码
  const [size, setSize] = useState<number>(10); // 每页显示数据数量
  const [total, setTotal] = useState<number>(0); // 总共数据量

  // 添加公司弹窗
  // 打开添加公司
  const [openAddCompany, setOpenAddCompany] = useState(false);
  const [comId, setComId] = useState('');
  const [inputComName, setInputComName] = useState('');
  const handleOk = async () => {
    // 弹窗内确定
    if (addTitle === '添加公司') {
      console.log('弹窗内确定', addTitle);
      // 添加公司
      const res = await api.addCompany({
        name: inputComName,
      });
      console.log('添加公司', res);
    } else if (addTitle === '编辑公司') {
      console.log('编辑公司', comId);
      // 编辑公司
      const res = await api.updateCompany({
        id: comId,
        name: inputComName,
      });
      console.log('编辑公司', res);
    }
    getCompanyList();
    setOpenAddCompany(false);
  };

  const handleCancel = () => {
    // 弹窗内取消
    setOpenAddCompany(false);
  };

  useEffect(() => {
    getCompanyList();
  }, [page, size]);

  return (
    <>
      <div className="wrap">
        {data.length > 0 || (data.length == 0 && inputValue.current !== undefined) ? (
          <div className="headerBar">
            <Input
              style={{ width: 350 }}
              prefix={<SearchOutlined />}
              allowClear
              onChange={onInputChange}
              onPressEnter={() => searchUsers(inputValue.current)}
              placeholder="搜索公司名称"
            />
            <div>
              <Button
                type="primary"
                ghost={false}
                onClick={() => {
                  setAddTitle('添加公司');
                  setOpenAddCompany(true);
                }}
                style={{ marginRight: 16 }}
              >
                添加公司
              </Button>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="memberTable" style={{ marginTop: 0 }}>
          <Spin spinning={tableLoad}>
            {data.length > 0 ? (
              <Table
                rowKey="usersId"
                columns={columns}
                dataSource={data}
                pagination={{
                  size: 'small',
                  showTotal: (total, range) => {
                    return `${range[0]}-${range[1]}条，共${total}条`;
                  },
                  showTitle: true,
                  showQuickJumper: false,
                  showSizeChanger: true,
                  total: total, // 分页总数
                  pageSize: size, // 每页数量
                  current: page, // 当前页数
                  onChange: (p, s) => {
                    console.log('公司列表翻页', { p, s });
                    setPage(p);
                    setSize(s as number);
                  },
                }}
                scroll={{ y: 'calc(100vh - 452px)' }}
              />
            ) : (
              <div className="emptyInfo">
                {/* <IconFont className={styles.emptyImage} type="icon-kong" /> */}
                {/* <EmptyFileColor style={{ marginTop: '120px' }} /> */}
                {/* <img src={EmptyIcon} className="emptyImage" /> */}
                {/* <div className="emptyBody">没有公司</div>
                <Button type="primary" className="emptyFooter">
                  <span
                    className="link"
                    onClick={() => {
                      setAddTitle('添加公司');
                      setOpenAddCompany(true);
                    }}
                    style={{ margin: '0 4px' }}
                  >
                    添加公司
                  </span>
                </Button> */}
                <PtxEmpty
                  isEmpty={!inputValue.current}
                  describe="没有公司"
                  icon={<EmptyFileColor />}
                  btnRender={() => {
                    if (inputValue.current) {
                      return undefined;
                    }
                    return (
                      <Button type="primary" className="emptyFooter">
                        <span
                          className="link"
                          onClick={() => {
                            setAddTitle('添加公司');
                            setOpenAddCompany(true);
                          }}
                          style={{ margin: '0 4px' }}
                        >
                          添加公司
                        </span>
                      </Button>
                    );
                  }}
                />
              </div>
            )}
          </Spin>
        </div>
      </div>
      {/* 添加公司 */}
      {openAddCompany && (
        <AddCompany
          handleOK={handleOk}
          handleCancel={handleCancel}
          showModal={openAddCompany}
          addTitle={addTitle}
          setInputComName={setInputComName}
          comName={comName}
          setComName={setComName}
        />
      )}
    </>
  );
};

export default ComponyList;
